import type { ImageTagColor } from '../../services/api/imageTagService';

// Tailwind は文字列リテラルからクラスを拾うので、色ごとにクラス名を書き切る
export const IMAGE_TAG_COLOR_CLASSES: Record<ImageTagColor, { chip: string; dot: string; swatch: string }> = {
  indigo: { chip: 'bg-indigo-50 text-indigo-700', dot: 'bg-indigo-500', swatch: 'bg-indigo-500 hover:bg-indigo-600' },
  pink: { chip: 'bg-pink-50 text-pink-700', dot: 'bg-pink-500', swatch: 'bg-pink-500 hover:bg-pink-600' },
  teal: { chip: 'bg-teal-50 text-teal-700', dot: 'bg-teal-500', swatch: 'bg-teal-500 hover:bg-teal-600' },
  amber: { chip: 'bg-amber-50 text-amber-800', dot: 'bg-amber-500', swatch: 'bg-amber-500 hover:bg-amber-600' },
  purple: { chip: 'bg-purple-50 text-purple-700', dot: 'bg-purple-500', swatch: 'bg-purple-500 hover:bg-purple-600' },
  sky: { chip: 'bg-sky-50 text-sky-700', dot: 'bg-sky-500', swatch: 'bg-sky-500 hover:bg-sky-600' },
  rose: { chip: 'bg-rose-50 text-rose-700', dot: 'bg-rose-500', swatch: 'bg-rose-500 hover:bg-rose-600' },
  lime: { chip: 'bg-lime-50 text-lime-800', dot: 'bg-lime-500', swatch: 'bg-lime-500 hover:bg-lime-600' },
};

export const IMAGE_TAG_COLOR_LABELS: Record<ImageTagColor, string> = {
  indigo: '青',
  pink: 'ピンク',
  teal: '緑',
  amber: '黄',
  purple: '紫',
  sky: '水色',
  rose: '赤',
  lime: '黄緑',
};

export const tagColorClasses = (color: string) =>
  IMAGE_TAG_COLOR_CLASSES[color as ImageTagColor] ?? IMAGE_TAG_COLOR_CLASSES.indigo;
